import { Icons } from "contents/icons";
import { create } from "zustand";

export interface AlertDialogForm {
  size: "small" | "large";
  state: "info" | "success" | "warning" | "error";
  title: string;
  body: { content: string | React.ReactNode; icon?: keyof typeof Icons };
  caption?: { content: string; icon?: keyof typeof Icons };
  preventClose?: boolean;
}

export interface ConfirmDialogForm extends AlertDialogForm {
  button?: {
    label?: string;
    preIcon?: keyof typeof Icons;
    postIcon?: keyof typeof Icons;
    disabled?: boolean;
    width?: string;
    onClick?: (
      e: React.MouseEvent<HTMLButtonElement>
    ) => Promise<boolean> | void;
  };
  secondButton?: {
    label?: string;
    preIcon?: keyof typeof Icons;
    postIcon?: keyof typeof Icons;
    disabled?: boolean;
    onClick?: (
      e: React.MouseEvent<HTMLButtonElement>
    ) => Promise<boolean> | void;
  };
}

export interface DialogStoreType {
  dialogForm: ConfirmDialogForm | null;
  setDialogForm: (form: ConfirmDialogForm | null) => void;
}

const useDialogStore = create<DialogStoreType>((set) => ({
  dialogForm: null,
  setDialogForm: (form: ConfirmDialogForm | null) => set({ dialogForm: form }),
}));

export default useDialogStore;
